/* eslint-disable @typescript-eslint/no-empty-function */
import { CloseIcon } from 'assets/icons/CloseIcon'
import { DashboardCard, P } from 'styling/GlobalStyles'
import { IWidget } from 'types/dashboard.interface'
import { WidgetEditOverlay } from 'pages/Dashboard/Dashboard.styled'
import { WidgetHeader, WidgetTitle } from './widgetParts.styled'
import { WidgetBody } from '../hrLayout.styled'
import { HrWidgetBody } from './HrWidgetBody'

export const HrNotificationWidget = ({ modalOpen, removeWidget, onDragOver, onDragStart, onDragDrop }: IWidget) => {
  return (
    <DashboardCard
      draggable={modalOpen}
      onDragStartCapture={() => onDragStart('notifications', 1)}
      onDrop={onDragDrop}
      onDragEnd={(e) => e.preventDefault()}
      onDragOver={(e) => {
        e.preventDefault()
        onDragOver('notifications')
      }}
      width='1fr'
      style={{ gridArea: 'notifications', cursor: modalOpen ? 'grab' : 'normal' }}
    >
      {modalOpen && (
        <WidgetEditOverlay
          onClick={(e) => {
            removeWidget('notifications')
            e.stopPropagation()
          }}
        >
          <P>Remove Widget</P>
          <CloseIcon />
        </WidgetEditOverlay>
      )}
      <WidgetHeader>
        <WidgetTitle>Notifications</WidgetTitle>
      </WidgetHeader>
      <WidgetBody>
        <HrWidgetBody type='notifications' />
      </WidgetBody>
    </DashboardCard>
  )
}
